import { useState } from "react";
import styles from "./styles.module.scss";
import img1 from './img/1.png'
import img2 from './img/2.png'
import img3 from './img/3.png'
import img4 from './img/4.png'
import img5 from './img/5.png'
import img6 from './img/6.png'
import img7 from './img/7.png'

import { Button } from "@common/index";
import { IconCard, IconCardCheckbox } from "src/routes/onboarding/shared";

const data = [
  {
    value: "Marriage or relationship",
    displayValue: "Marriage or relationship",
    emoji: img1
  },
  {
    value: "Pregnancy",
    displayValue: "Pregnancy",
    emoji: img2
  },
  {
    value: "Busy work or family life",
    displayValue: "Busy work or family life",
    emoji: img3
  },
  {
    value: "Financial struggles",
    displayValue: "Financial struggles",
    emoji: img4
  },
  {
    value: "High stress or anxiety",
    displayValue: "High stress or anxiety",
    emoji: img5
  },
    {
    value: "Medicine or hormonal disorder",
    displayValue: "Medicine or hormonal disorder",
    emoji: img6
  },
];
export const HoldingsBack2 = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState([]);

  const handleCheck = (value) => {
    setChecked((prevState) => {
      if (prevState.includes(value)) {
        return prevState.filter((item) => item !== value);
      }

      return [...prevState, value];
    });
  };

  const handleNextStep = () => {
    onNextStep?.(checked);
    onTrackEvent?.(checked);
  };

  const handleSelectNone = () => {
    setChecked([]);
    handleNextStep();
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Choose any life events that have led to weight gain</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardCheckbox
              checked={checked.includes(value.value)}
              onClick={() => handleCheck(value.value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.value}
              variant='walky'
            />
          ))}
          <IconCard
            title="None of the above"
            img={img7}
            onClick={handleSelectNone}
          />
        </div>
      </div>
      <div className={styles.action}>
        <Button variant='walky' disabled={!checked.length} onClick={handleNextStep}>
          Continue
        </Button>
      </div>
    </div>
  );
};
